import { registerCapability } from '../../platform/capability-registry';
import { MaasSystemConfigBlock } from './MaasSystemConfigBlock';
import { MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST } from './fieldKeys';
import { resolveMaasSystemConfigPaths } from './resolvePaths';
import type { MaasSystemConfigBlockOptions } from './types';

registerCapability<MaasSystemConfigBlockOptions>({
  key: 'maas-system-config',
  fields: [...MAAS_SYSTEM_CONFIG_FIELD_KEY_LIST],
  component: MaasSystemConfigBlock,
  defaultPaths: (prefix) => resolveMaasSystemConfigPaths(prefix),
  resolvePaths: (prefix) => resolveMaasSystemConfigPaths(prefix),
});
